import {menusNames as mn, menuProps as mp} from "../../constants/menus";

// initial state
const state = {
    list: jsonData.editors.list,
    backgrounds: jsonData.editors.backgrounds,
    slides: null,
    editor: null,
    hovered: null,
    reel: null,
    media: null,
    inited: false,
    remember: null,
}

let slidesMap = {}

// getters
const getters = {
    // active editor is:
    // 1. which has active-flag
    // 2. inactive editor, URL to which was first, when user started site-navigation
    active: (state) => {
        let active = state.list.filter((el, index) => {
            return el.active
        })

        // NOTE: remember-editor should be rendered as latest in Menu (Editors.vue)
        if (state.remember) {
            active.push(state.remember)
        }

        return active
    },
    slides: (state) => state.slides,
    hoveredEditor: (state) => state.hovered,
    editor(state) {
        return state.editor
    },
    reel(state) {
        return state.reel
    },
    media(state) {
        return state.media
    },
    medias(state, getters) {
        return getters.reel && getters.reel.list || []
    },
}

// actions
const actions = {
    clean({commit}) {
        commit('clean')
    },
    initEditorState({commit, dispatch, state}, params) {
        //console.log('initEditorState');
        //debugger
        dispatch('player/clean', params, {root: true})
        dispatch('clean')
        dispatch('initEditor', params)
        dispatch('initReel', params)
        dispatch('initMedia', params)
    },

    initEditor({commit, state, rootState, rootGetters}, params) {
        //debugger
        let editor = state.list.find((editor) => editor.slug === params.editor)

        if (!editor) {
            return
        }

        commit('setEditor', editor)
        commit('player/setBack', rootGetters['routes/getProp'](mn.EDITORS, mp.LINK), {root: true})
    },
    initReel({commit, state}, params) {
        //debugger
        let editor = state.editor

        if (!editor) {
            return
        }

        let reels = editor.reels
        //let reel = []
        let reel = null

        if (params.reel && reels.length) {
            reel = reels.find((reel, ind, arr) => reel.slug === params.reel)
        } else if (!params.reel && reels.length) {
            reel = reels[0]
        }

        commit('setReel', reel)
    },
    initMedia({commit}, params) {
        //debugger
        let reel = state.reel

        if (!reel) {
            return
        }

        let medias = reel.list
        params.detail = params.detail || ''

        let media = medias.find((media) => media.slug === params.detail)
        commit('setMedia', media)

        if (media) {
            commit('player/setBack', reel.link, {root: true})
            commit('player/setList', medias, {root: true})
            commit('player/setCurrent', media, {root: true})
        }
    },
    setHoveredEditor({commit}, editor) {
        commit('setHoveredEditor', editor)
    },
    initSlides({state, getters, commit}) {
        if (state.slides) {
            return
        }

        //debugger
        let slides = []
        let slide = null
        let mediaIdx = null

        getters.active.map((editor, i) => {
            let editorSlides = state.backgrounds.list.filter((background) => {
                return background.credits.editor.name.trim().toLowerCase() === editor.name.trim().toLowerCase()
            })

            slide = editorSlides[0]
            mediaIdx = 0

            if (!slide) {
                slide = mediaIdx = null
            }

            slidesMap[i] = {
                slides: editorSlides,
                mediaIdx: mediaIdx,
                slide: slide,
            }
            slides[i] = slide
        })

        commit('setSlides', slides)
    },
    nextSlide({state, commit}, idx) {
        //debugger
        let editor = state.list[idx]
        let currSlide = slidesMap[idx]
        let nextSlide = null

        nextSlide = currSlide.slides[currSlide.mediaIdx + 1]

        if (nextSlide) {
            slidesMap[idx].mediaIdx++
            slidesMap[idx].slide = nextSlide

            commit('setSlide', {slide: nextSlide, index: idx})
            return
        }

        nextSlide = currSlide.slides[0]

        if (nextSlide) {
            slidesMap[idx].mediaIdx = 0
            slidesMap[idx].slide = nextSlide

            commit('setSlide', {slide: nextSlide, index: idx})
            return
        }

        slidesMap[idx].mediaIdx = null
        slidesMap[idx].slide = null

        commit('setSlide', {slide: nextSlide, index: idx})
    }
}

// mutations
const mutations = {
    clean(state) {
        state.editor = null
        state.reel = null
        state.media = null
    },
    setEditor(state, editor) {
        state.editor = editor

        // 1. if user starts site-navigation using INACTIVE editor's URL - then user SHOULD SEE THIS editor in Menu also
        // 2. if user starts site-navigation using any other URL (except inactive editor) - then user should see in Menu
        // ONLY ACTIVE editors
        if (!editor.active && !state.remember) {
            state.remember = editor
        }
    },
    setReel(state, reel) {
        state.reel = reel
    },
    setMedia(state, media) {
        state.media = media
    },
    setLoadedMedia(state, media) {
        Vue.set(media, '_loaded', true)
    },
    setHoveredEditor(state, editor) {
        state.hovered = editor
    },
    setLoadedBackground(state, slide) {
        Vue.set(slide, '_loaded', true)
    },
    setSlides(state, slides) {
        state.slides = slides
    },
    setSlide(state, {slide, index}) {
        Vue.set(state.slides, index, slide)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
